import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'
import { transparentize } from 'polished'

export const ReviewEntryClarificationCardWrapper = styled.div`
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  gap: ${Spacing.S12};
  min-width: 0;
  max-width: 600px;
  padding: ${Spacing.S20} ${Spacing.S40} ${Spacing.S20} ${Spacing.S16};
  border: 1.5px solid ${Color.Purple600};
  border-radius: ${BorderRadius.R12};
  position: relative;
  box-shadow: 0 2px 8px ${transparentize(0.88, Color.Black)};
`

export const ReviewEntryClarificationCardClose = styled.div`
  position: absolute;
  top: ${Spacing.S8};
  right: ${Spacing.S8};
`

export const ReviewEntryClarificationCardTag = styled.div`
  align-self: flex-start;
`
